module.exports = __webpack_public_path__ + "assets/USDT(TRC20).c70ee5a2.svg";